import * as React from 'react'

import Button from '../../atoms/Button/Button'
import ArrowRightSvg from '../../atoms/Icons/Button/ArrowRight'
import ArrowLeftSvg from '../../atoms/Icons/Button/ArrowLeft'

import * as Styled from './NavigationButtons.styles'
import { Action, Category } from '../../../util/analytics-data-attributes/analyticsAttributes'

type AnalyticsAttributes = {
  action: Action
  category: Category
  label?: string
}

export type ButtonAttrs = {
  analytics?: AnalyticsAttributes
  label?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
}

type NavigationButtonsProps = {
  next: ButtonAttrs
  previous?: ButtonAttrs
  className?: string
}

const NavigationButtons: React.FunctionComponent<NavigationButtonsProps> = ({ next, previous, className }) => (
  <Styled.NavigationButtons className={className}>
    {previous ? (
      <Button
        dataAnalyticsAction={previous.analytics?.action}
        dataAnalyticsCategory={previous.analytics?.category}
        dataAnalyticsLabel={previous.analytics?.label}
        onClick={previous.onClick}
        size={Button.Sizes.large}
        variant={Button.Variants.secondary}
        disabled={previous.disabled}
        data-testid="previous-button"
      >
        {previous.label ? (
          previous.label
        ) : (
          <>
            <ArrowLeftSvg />
            &nbsp;&nbsp; Vorige
          </>
        )}
      </Button>
    ) : (
      <div />
    )}
    <Styled.NextButton
      dataAnalyticsAction={next.analytics?.action}
      dataAnalyticsCategory={next.analytics?.category}
      dataAnalyticsLabel={next.analytics?.label}
      onClick={next.onClick}
      disabled={next.disabled}
      size={Button.Sizes.large}
      data-testid="next-button"
    >
      {next.label ? (
        next.label
      ) : (
        <>
          Volgende &nbsp;&nbsp; {next.disabled} <ArrowRightSvg />
        </>
      )}
    </Styled.NextButton>
  </Styled.NavigationButtons>
)

export default NavigationButtons
